
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return require("private-next-pages/about.tsx");
      }
    ]);
  